/**
 * @generated SignedSource<<438ad6e1c448f39a99bdc9e573bd1741>>
 * @relayHash 58a98563909ffa177b03f6e93baf45ca
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 58a98563909ffa177b03f6e93baf45ca

import { ConcreteRequest } from 'relay-runtime';
export type Ch_confirmDuplicatePatientsInput = {
  duplicatePatientIds: ReadonlyArray<string>;
  primaryPatientId: string;
  reason: string;
  undoDuplicatePatientIds: ReadonlyArray<string>;
};
export type chConfirmDuplicatePatientsMutation$variables = {
  input: Ch_confirmDuplicatePatientsInput;
};
export type chConfirmDuplicatePatientsMutation$data = {
  readonly ch_confirmDuplicatePatients: {
    readonly ch_Patient: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chConfirmDuplicatePatientsMutation = {
  response: chConfirmDuplicatePatientsMutation$data;
  variables: chConfirmDuplicatePatientsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_Patient",
  "kind": "LinkedField",
  "name": "ch_Patient",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chConfirmDuplicatePatientsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_confirmDuplicatePatientsPayload",
        "kind": "LinkedField",
        "name": "ch_confirmDuplicatePatients",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chConfirmDuplicatePatientsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_confirmDuplicatePatientsPayload",
        "kind": "LinkedField",
        "name": "ch_confirmDuplicatePatients",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "58a98563909ffa177b03f6e93baf45ca",
    "metadata": {},
    "name": "chConfirmDuplicatePatientsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "aea0cea6ffea435b19fdc9b3745db673";

export default node;
